module.exports = __webpack_public_path__ + "static/media/shoe.bcf80dfa.png";